import { envConfig } from 'envConfig'

export const isBasicAuthEnabled = () => envConfig.env !== 'production'
